import { AppState } from 'src/types/appState'

export const currentTabIndexSelector = (state: AppState) => {
  return state.calendar.currentTabIndex
}
